import React, { useEffect, useState } from 'react';
import { Clock3 } from 'lucide-react';
import { formatBusinessTime, BUSINESS_TIME_ZONE_LABEL } from '../lib/dateTime';

const BusinessClock = ({ className = '' }) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => window.clearInterval(timer);
  }, []);

  return (
    <div className={`inline-flex items-center gap-3 rounded-lg bg-card/70 px-4 py-2 shadow-[0_12px_32px_-24px_rgba(15,23,42,0.24)] ${className}`.trim()}>
      <Clock3 className="h-4 w-4 text-primary" />
      <div className="leading-tight">
        <p className="font-mono text-sm font-semibold text-foreground">{formatBusinessTime(now)}</p>
        <p className="text-[11px] text-muted-foreground">{BUSINESS_TIME_ZONE_LABEL}</p>
      </div>
    </div>
  );
};

export default BusinessClock;
